import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { StaticViewDataService } from '../../service/static-view-data-service.service';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { Subject } from 'rxjs';
import { LocalstorageService } from '../../service/localstorage.service';
import { environment } from '../../../environments/environment';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-all-story-listing',
  templateUrl: './all-story-listing.component.html',
  styleUrls: ['./all-story-listing.component.scss']
})
export class AllStoryListingComponent implements OnInit, OnDestroy {
  storyData: any;
  tempQuickRead: any;
  quickReadMax: any;
  savingQuickReadInProgress: boolean;
  quickReadSrc: string;
  summaryStatus:string;
  viewParagraph = [];
  userRestrictedSections: any = [];
  userRestrictedStoryTypes: any = [];
  maxPlagiarism: number;
  openNotificationPopup: boolean;
  notificationList: any;
  tabIndexValue: any;
  @Input()
  set byAuthor(byAuthor_string: string) {
    this.by_Author = (byAuthor_string && byAuthor_string.trim()) ? byAuthor_string : null;
  }
  by_Author;
  hideListing = false;
  getDataUrl = '';
  metaDataUrl = '';
  @ViewChild('listingInput', {static: false}) searchInput: ElementRef;
  socketsAllowed = [];
  filterList = [];
  facets = null;
  pageNum = 0;
  listArray = [];
  listIdArray = [];
  noresults = false;
  page_id = StaticDataService.story_page_id;
  all_element_api = StaticDataService.element_byids_api;
  get_api = StaticDataService.story_get_api;
  save_api = StaticDataService.story_save_api;
  lockAcquire_api = StaticDataService.story_lockAcquire_api;
  lockRelease_api = StaticDataService.story_lockRelease_api;
  searchQuery: FormControl = new FormControl();
  private stompClient;
  pageSize = 50;
  pageSizeArray = [50, 100, 150, 200];
  sortByValueOf = null;
  exactMatch = false;
  filterUrl = {};
  fields = '';
  initialUrl = '';
  latestUrl = '';
  suggestionDataUrl = '';
  callFail = false;
  pages = 0;
  totalRecords = 0;
  listSuggestionArray = [];
  showSuggestionBox = false;
  str = '';
  enablePlagiarism = this.sharedService.isdomainConfig('story','enablePlagiarism');
  automaticQuickReadEnabled = this.sharedService.isdomainConfig('story','automaticQuickReads');
  automaticSummaryReadEnabled = this.sharedService.isdomainConfig('story','automaticSummaryReadEnabled');
  searchFocus = false;
  @ViewChildren('listingInput') searchField;
  arrowkeyLocation = 0;
  valueChangeEvent = true;
  showMore = false;
  headerList = [];
  unlockOptions = null;
  @ViewChild('clipboardInput', {static: false}) clipboardInput: ElementRef;
  unlockPopup = false;
  quickReadPopup = false;
  lockedUser;
  lockedId;
  routeLinkForList;
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  @ViewChildren('listData2') listData: ElementRef;
  timings = {
    constr: 0,
    onin: 0,
    resp: 0,
    list: 0,
    getEnv: 0,
    getMeta: 0
  };
  private subject: Subject<string> = new Subject();
  isAuthorIdEnabled = false;
  domainConfig = null;
  enableAMPValidation = false;
  showStoryParaView = false;
  showQuickReads = true;
  showMy = false;
  constructor(
    private config: Config,
    private restService: RestDataService,
    private snotify: SnotifyService,
    private sharedService: SharedDataService,
    private router: Router,
    private localstorageService:LocalstorageService
  ) {

    this.timings.constr = performance.now();
    console.log('constructor => 0');
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
  }

  getDomainConfig(currentDomainConfig) {
    this.domainConfig = currentDomainConfig;
    this.isAuthorIdEnabled = (currentDomainConfig && currentDomainConfig['config']
    && currentDomainConfig['config']['story'] && currentDomainConfig['config']['story']['authorId']
    && currentDomainConfig['config']['story']['authorId'] === 'true');
    this.enableAMPValidation = (currentDomainConfig && currentDomainConfig['config']
    && currentDomainConfig['config']['story'] && currentDomainConfig['config']['story']['enableAMPValidation']
    && currentDomainConfig['config']['story']['enableAMPValidation'] === 'true');
    this.getQuickReadMax();
  }

  ngOnInit() {
    this.tabIndexValue = 0;
    this.timings.onin = performance.now();
    console.log('oninit => ', performance.now() - this.timings.constr);
    this.getDataUrl = this.config.get('product').baseUrl + StaticViewDataService.Story_listing_View.urls.listing;
    this.metaDataUrl = this.config.get('product').baseUrl + StaticViewDataService.Story_listing_View.urls.meta;
    this.suggestionDataUrl = this.config.get('product').baseUrl + StaticViewDataService.Story_listing_View.urls.suggestion;
    this.socketsAllowed = StaticViewDataService.Story_listing_View.socketCodes;
    const filters = StaticViewDataService.Story_listing_View.filters;
    this.filterList = this.sharedService.getUpdatedFilters(filters, "story");
    this.fields = StaticViewDataService.Story_listing_View.fields;
    this.headerList = StaticViewDataService.Story_listing_View.headers;
    this.routeLinkForList = StaticViewDataService.Story_listing_View.list_router;
    this.getUserPermittedSections();
    this.getUserPermittedStoryTypes();
    this.timings.getEnv = performance.now();
    console.log('getEnv => ', performance.now() - this.timings.onin);

    if(this.enablePlagiarism) {
      if(this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story'] &&
            this.domainConfig['config']['story']['maxPlagiarism']) {
              this.maxPlagiarism = Number(this.domainConfig['config']['story']['maxPlagiarism']);
      } else {
        this.maxPlagiarism = 75;
      }
    }

    if (this.searchInput) {
      this.searchInput.nativeElement.focus();
    }

    if (StaticViewDataService.Story_listing_View.sortBy) {
      this.sortByValueOf = StaticViewDataService.Story_listing_View.sortBy;
    }

    if (this.metaDataUrl && this.metaDataUrl.trim() !== '' ) {
      // if(!localStorage.getItem('metaData')){
        this.restService.http_get(this.metaDataUrl)
        .subscribe(data => {
          this.facets = data;
          console.log('all-story-listing metadata',this.facets)
         localStorage.setItem('metaData',JSON.stringify(this.facets));//adding meta data for reusing
         });
      // }
      // else{
      //   let metaData=this.localstorageService.getMetaData();
      //   console.log('else part all-story-listing metadata',this.facets)
      //   this.facets=metaData;
      // }

    }
    this.timings.getMeta = performance.now();
    console.log('getmeta => ', performance.now() - this.timings.getEnv);

    this.getDefaultList(0, this.dataInsertion);
    this.showSuggestionBox = false;


    this.subject
      .pipe(debounceTime(800)
      ,distinctUntilChanged())
      .subscribe(result => {
        // this.str = result;
        this.getautoSuggestion(result, data => {
          this.listSuggestionArray = [];
          // console.log(data);
          const dataSuggestion = data;
          if (dataSuggestion && dataSuggestion.length > 0) {
            for (let i = 0; i < dataSuggestion.length; i++) {
              this.listSuggestionArray.push(dataSuggestion[i]);
            }
            this.showSuggestionBox = true;
          } else {
            this.showSuggestionBox = false;
          }
        });
      });

    if (!this.by_Author) {
      if(this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['socket'] && this.domainConfig['config']['socket']['enableSocket'] && this.domainConfig['config']['socket']['enableSocket'] === 'true')
      {
        this.initializeWebSocketConnection();
      }
    }
  }
  getQuickReadMax() {
    this.quickReadMax = this.domainConfig['config']['story']['quickReadMax'] ?
                               Number(this.domainConfig['config']['story']['quickReadMax']) : 60;
  }

  htmlToPlaintext(text) {
    if (typeof text === 'string') {
      return text ? this.htmlSpecialCharToText(String(text).replace(/<[^>]+>/gm, '')) : '';
    } else {
      return text;
    }
  }

  getUserPermittedSections() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const restrictedSectionsObj = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].sections
    // this.userRestrictedSections
    if(restrictedSectionsObj && restrictedSectionsObj.length>0) {
      for(let item of restrictedSectionsObj) {
        if(item) {
          this.userRestrictedSections.push(item.alias)
        }
      }
    }
    // console.log(this.userRestrictedSections)
  }
  getUserPermittedStoryTypes() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const restrictedStoriesObj = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].story
    // this.userRestrictedSections
    
    if(restrictedStoriesObj && restrictedStoriesObj.length > 0) {
      for(let item of restrictedStoriesObj) {
        if(item) {
          this.userRestrictedStoryTypes.push(item.name)
        }
      }
    }
    
    // console.log(this.userRestrictedSections)
  }

  htmlSpecialCharToText(text) {
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
      'nbsp': ' ',
      'amp': '&',
      'quot': '\'',
      'lt': '<',
      'gt': '>'
    };
    return (text.replace(translate_re,
      (match, entity) => {
        return translate[entity];
      })
    );
  }

  plagStatus(item) {
    if(item.metadata.plagiarismChecked && item.metadata.plagiarisedContent>=0 ) {
      return ('Plagiarism Percent - ' + item.metadata.plagiarisedContent + '%');
    }
    return ('Plagiarism Percent - NA');
  }

  plagIconCheck(item){
    if(item.metadata.plagiarismChecked && item.metadata.plagiarisedContent>=0) {
      if(item.metadata.plagiarisedContent <= this.maxPlagiarism) {
        return 'assets/images/plag_icon_green.svg';
      } else {
        return 'assets/images/plag_icon_red.svg';
      }
    }
    return 'assets/images/plag_icon_gray.svg';
  }

  initializeWebSocketConnection() {
    const ws = new SockJS(this.config.get('product').socketUrl
      + '?access_token='
      + JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).access_token);
    this.stompClient = Stomp.over(ws);
    this.stompClient.debug = false;
    const self = this;
    const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.stompClient.connect({}, function (frame) {
      if (self.socketsAllowed.indexOf(1) > -1) {
        console.log('story dashboard socket online!', domain);
        self.stompClient.subscribe('/topic/article-lock-' + domain, (message) => {
          const tempObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(tempObj.articleId);
          if (j > -1 && self.listArray[j].id === tempObj.articleId && (self.initialUrl === self.latestUrl)) {
            self.listArray[j].lockedByUserId = tempObj.lockedByUserId;
            self.listArray[j].lockedByUserName = tempObj.lockedByUserName;
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }

      if (self.socketsAllowed.indexOf(2) > -1) {
        console.log('story update socket online!');
        self.stompClient.subscribe('/topic/story-update-' + domain, (message) => {
          const bodyObj = JSON.parse(message.body);
          // console.log(bodyObj);
          if (bodyObj['type'] === 'story') {
            const j = self.listIdArray.indexOf(bodyObj.id);
            if ((j > -1) && (self.listArray[j].id === bodyObj.id) && (self.initialUrl === self.latestUrl)) {
              self.listArray[j] = bodyObj;
            }
            if (j < 0 && (self.initialUrl === self.latestUrl)) {
              self.listIdArray.unshift(bodyObj.id);
              self.listArray.unshift(bodyObj);
            }
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }

      if (self.socketsAllowed.indexOf(7) > -1) {
        self.stompClient.subscribe('/topic/story-delete-' + domain, (message) => {
          const bodyObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(bodyObj);
          self.listArray.splice(j, 1);
          self.listIdArray.splice(j, 1);
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }
    },
      err => {
        console.log(err);
      });
  }
  onClickStory(item, type){
    if(type === 'click') {
      let link = this.routeLinkForList + '/' + item.id;
      this.router.navigate([link]);
    } else if(type === 'ctrl-click') {
      window.open(window.location.origin + this.routeLinkForList + '/' + item.id, "_blank");
    }
  }

  fetchParaContent() {
    if(this.storyData && this.storyData.elements && this.storyData.elements.length > 0) {
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api),
        this.storyData.elements,
        res => {
          if (res && (res !== null) && !res.hasOwnProperty('error')) {
            for(let item of res) {
              if(item.type === 'paragraph') {
                this.viewParagraph.push(item.paragraph.body)
              }
            }
            console.log(this.viewParagraph)

          } else {
            console.log("ERROR")
          }
        });
    } else {
      this.viewParagraph = ['Empty Story'];
    }
  }

  getautoSuggestion(query, callback) {
    if (query && query.trim() !== '') {
      const tempQuery = query;
      // this.str = tempQuery;
      query = query.split(' ');
      query = query[(query.length - 1)];
      if (query.length > 2 && this.valueChangeEvent) {
        this.showSuggestionBox = false;
        const url = this.suggestionDataUrl + '?text=' + StaticDataService.encodeSpecialChar(tempQuery);
        this.restService.http_get(url)
          .subscribe(data => {
            callback(data);
          },
            error => {
              // console.log(error);
            });
      }
    } else {
      this.getDefaultList(0, this.dataInsertion);
      this.showSuggestionBox = false;
    }
  }

  searchResults(query, pageNum, callback) {
    if (query && query.trim() !== '') {
      let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
      if (this.sortByValueOf) {
        url += '&sort=' + this.sortByValueOf + ',desc';
      }
      url += this.fields;
      if (this.exactMatch) {
        url += '&exact=true';
      }
      url += '&search=';
      if (this.by_Author) {
        //url += ',readByUsers:' + this.by_Author;
        url += ',readByUsers:' + this.by_Author + '@@proofReadByUsers**'+ this.by_Author;
      }
      if(this.userRestrictedSections && this.userRestrictedSections.length > 0) {
        console.log(this.userRestrictedSections)
        url += ',metadata.section:'
        for(let sec of this.userRestrictedSections) {
          url += sec + (this.userRestrictedSections.length > 1 ? ';' : '');
        }
      }
      if(this.userRestrictedStoryTypes && this.userRestrictedStoryTypes.length > 0) {
        url += ',type:'
        for(let sec of this.userRestrictedStoryTypes) {
          url += sec + (this.userRestrictedStoryTypes.length > 1 ? ';' : '');
        }
     }
      if (this.filterUrl) {
        for (const filter in this.filterUrl) {
          if (filter) {
            url += this.filterUrl[filter];
          }
        }
      }
      const querArr = query.split(':');
      if (querArr && querArr.length > 1 && querArr[0].toUpperCase() === 'ID') {
        url += ',id:' + querArr[1].trim();
      } else {
        url += ',text~' + StaticDataService.encodeSpecialChar(query);
      }
      this.callFail = false;
      this.latestUrl = url;
      this.timings['firstGet'] = performance.now();
      console.log('firstGet => ', performance.now() - this.timings.getMeta);
      this.restService.http_get(url)
        .subscribe(data => {
          this.timings.resp = performance.now();
          console.log('response received => ', performance.now() - this.timings['firstGet']);
          this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
          this.totalRecords = data['totalElements'];
          this.topFunction();
          this.callFail = false;
          this.measureTime(0);
          callback(data);
        },
          error => {
            this.callFail = true;
            // console.log(error);
          });
    } else {
      this.getDefaultList(pageNum, data => {
        callback(data);
      });
    }
  }

  getDefaultList(pageNum, callback) {
    let emailId=localStorage.getItem('emailId');
    let url = this.getDataUrl + '?page=' + pageNum + '&size=' + this.pageSize;
    if (this.sortByValueOf) {
      url += '&sort=' + this.sortByValueOf + ',desc';
    }
    url += this.fields;
    if (this.exactMatch) {
      url += '&exact=true';
    }
    url += '&search=';
    if (this.by_Author) {
      url += ',readByUsers:' + this.by_Author;
    }
    if(this.userRestrictedSections && this.userRestrictedSections.length > 0) {
        url += ',metadata.section:'
        for(let sec of this.userRestrictedSections) {
          url += sec + (this.userRestrictedSections.length > 1 ? ';' : '');
        }
    }
    if(this.userRestrictedStoryTypes && this.userRestrictedStoryTypes.length > 0) {
      url += ',type:'
      for(let sec of this.userRestrictedStoryTypes) {
        url += sec + (this.userRestrictedStoryTypes.length > 1 ? ';' : '');
      }
   }
    
    // if(!!emailId && this.by_Author){
    //   url += ';' + emailId;
    // }
    if(!!emailId && this.by_Author){
      url += ';' + emailId + '@@proofReadByUsers**'+ this.by_Author + ';' + emailId;
    }
    else if(this.by_Author)
    {
      url += '@@proofReadByUsers**'+ this.by_Author;
    }
    console.log(url)
    if (this.filterUrl) {
      for (const filter in this.filterUrl) {
        if (filter) {
          url += this.filterUrl[filter];
        }
      }
    }
    this.callFail = false;
    if (this.initialUrl === '') {
      this.initialUrl = url;
    }
    this.latestUrl = url;

    this.timings['firstGet'] = performance.now();
    console.log('firstGet => ', performance.now() - this.timings.getMeta);
    this.restService.http_get(url)
      .subscribe(data => {
        this.timings.resp = performance.now();
        console.log('response received => ', performance.now() - this.timings['firstGet']);
        this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
        this.totalRecords = data['totalElements'];
        this.callFail = false;
        this.topFunction();
        this.measureTime(0);
        callback(data);
      });
  }

  dataInsertion = (data) => {
    const results = data['content'];
    this.listArray = [];
    this.listIdArray = [];
    if (results && results.length > 0) {
      this.listArray = results;
      this.listIdArray = results.map(e => e.id);
      this.noresults = false;
    } else {
      this.noresults = true;
    }
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    if (document.getElementsByClassName('contentList') && document.getElementsByClassName('contentList').length > 0) {
      document.getElementsByClassName('contentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }

  arrayOne(n: number) {
    return Array(n);
  }

  onPageNumberChange(pagenum) {
    this.pageNum = pagenum;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  onPageSizeChange(size) {
    this.pageNum = 0;
    this.pageSize = size;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  getsearchResults(item) {
    this.searchResults(item, 0, data => {
      this.str = item;
      this.pageNum = 0;
      this.dataInsertion(data);
      if (data && data['content'] && data['content'].length > 0) {
        this.showSuggestionBox = false;
        this.valueChangeEvent = false;
      } else {
        this.showSuggestionBox = true;
        this.valueChangeEvent = true;
      }
    });
  }

  onKeydown(event, input) {
    // console.log(event.keyCode, this.arrowkeyLocation, this.listSuggestionArray);
    // const ctrl_v = ((event.ctrlKey || event.metaKey) && event.keyCode === 86);
    // console.log(ctrl_v)
    if (event.key === 'Enter') {
      this.getsearchResults(this.str);
      this.showSuggestionBox = false;
    } else if (event.keyCode === 32) {
      this.getautoSuggestion(this.str, data => {
        this.listSuggestionArray = [];
        const dataSuggestion = data;
        if (dataSuggestion && dataSuggestion.length > 0) {
          for (let i = 0; i < dataSuggestion.length; i++) {
            this.listSuggestionArray.push(dataSuggestion[i]);
          }
          this.showSuggestionBox = true;
        } else {
          this.showSuggestionBox = false;
        }
      });
    } else if (event.keyCode === 40 && this.arrowkeyLocation < this.listSuggestionArray.length - 1) {
      this.valueChangeEvent = false;
      this.showSuggestionBox = true;
      this.arrowkeyLocation++;
      this.str = this.listSuggestionArray[this.arrowkeyLocation];
    } else if (event.keyCode === 38 && this.arrowkeyLocation > 0) {
      this.valueChangeEvent = false;
      this.showSuggestionBox = true;
      this.arrowkeyLocation--;
      this.str = this.listSuggestionArray[this.arrowkeyLocation];
    } else {
      // console.log(input)
      if( !(event.ctrlKey || event.metaKey)) {
        this.subject.next(input.value);
        this.valueChangeEvent = true;
        this.arrowkeyLocation = 0;
      }
    }
    return true;
  }

  toggleSwitch(model) {
    if (model === 'exact') {
      this.exactMatch = !this.exactMatch;
      this.searchResults(this.str, this.pageNum, this.dataInsertion);
    }
  }

  callToggles(ev, model) {
    const key = ev.keyCode || ev.charCode;
    if (key === 13) {
      ev.preventDefault();
      this.toggleSwitch(model);
      ev.stopPropagation();
    }
  }

  getFilterData(facet_name) {
    if (this.facets && this.facets[facet_name]) {
      return this.facets[facet_name];
    } else {
      return null;
    }
  }

  urlUpdate(ev) {
    this.filterUrl[ev.type] = ev.data;
    this.pageNum = 0;
    this.searchResults(this.str, this.pageNum, this.dataInsertion);
  }

  checkFocusInside(elem) {
    return (elem && elem.contains(document.activeElement));
  }

  getclassonCondition(lockStatus, storyStatus) {
    let ulClass = null;
    if (lockStatus && storyStatus === 'PUBLISHED') {
      ulClass = 'publishlockedIcon';
    } else if (lockStatus) {
      ulClass = 'lockedIcon icon-lock';
    } else if (storyStatus === 'PUBLISHED') {
      ulClass = 'publishIcon icon-published';
    }
    return ulClass;
  }

  openOptions(index) {
    const storyStatus = this.listArray[index].metadata.status;
    if (this.listArray[index].type !== 'video') {
      if (storyStatus === 'PUBLISHED' && this.listArray[index].lockedByUserId) {
        if (this.unlockOptions === index) {
          this.unlockOptions = null;
        } else {
          this.unlockOptions = index;
        }
      } else if (storyStatus === 'PUBLISHED' && !this.listArray[index].lockedByUserId) {
        this.unlockOptions = null;
        this.copyUrl(index);
      } else if (storyStatus !== 'PUBLISHED' && this.listArray[index].lockedByUserId) {
        this.openUnlock(index);
        this.unlockOptions = null;
      }
    } else {
      if (storyStatus === 'PUBLISHED') {
        const id = this.listArray[index].elements[0];
        if (this.unlockOptions === index) {
          this.unlockOptions = null;
        } else {
          this.restService.http_get(
            this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
            + '/' + id
          )
            .subscribe(result => {
              // console.log(result);
              if (!result.hasOwnProperty('error') && result.video.body !== null) {
                const embed = result.video.body;
                this.clipboardInput.nativeElement.value = embed;
              }
            });
          this.unlockOptions = index;
        }
      } else if (storyStatus !== 'PUBLISHED' && this.listArray[index].lockedByUserId) {
        this.openUnlock(index);
        this.unlockOptions = null;
      }
    }
  }

  copyUrl(index) {// rohit
    const url = this.listArray[index].metadata.url;
    if (url.charAt(0) === '/') {
      if(this.sharedService.currentDomainUrl === null || this.sharedService.currentDomainUrl === undefined || this.sharedService.currentDomainUrl.trim() === ''){
        let obj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
        if(obj)
        this.copyFunction(obj[0].baseUrl  + url);
      } else {
      this.copyFunction(this.sharedService.currentDomainUrl + url);
      }
    } else {
      this.copyFunction(url);
    }
    this.snotify.info('URL copied to Clipboard', '', this.sharedService.getConfig(false));
  }

  copyFunction(text) {
    const selBox = document.createElement('textarea');
    selBox.value = String(text);
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  openUnlock(index) {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = localStorage.getItem(StaticDataService.tokenLiteral) ?
      JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role
      : null;
    if (role && (role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN' && role !== 'ROLE_EDITOR' && role!=='ROLE_SITE_MANAGER')) {
      this.snotify.warning('You don’t have permission to unlock', '', this.sharedService.getConfig(false));
    } else {
      this.unlockPopup = true;
      this.sharedService.overflowhidden();
      this.lockedUser = this.listArray[index].lockedByUserName;
      this.lockedId = this.listArray[index].id;
    }
  }

  copyEmbed(inputElement) {
    if (inputElement.value.trim() !== '') {
      inputElement.select();
      document.execCommand('copy');
      inputElement.setSelectionRange(0, 0);
      inputElement.value = '';
      this.snotify.info('Video Embed copied to Clipboard', '', this.sharedService.getConfig(false));
    } else {
      this.snotify.error('Something bad happened', '', this.sharedService.getConfig(false));
    }
  }

  cancelUnlock() {
    this.unlockPopup = false;
    this.lockedUser = '';
    this.lockedId = null;
    this.sharedService.overflowauto();
  }

  unlockStory() {
    this.unlockPopup = false;
    this.sharedService.overflowauto();
    this.restService.http_get(
      this.config.get('product').baseUrl
      + StaticViewDataService.Story_listing_View.urls.unlock
      + '?articleId='
      + String(this.lockedId)
    )
      .subscribe(
        data => {
          this.lockedUser = '';
          this.lockedId = null;
          this.snotify.success('Story Unlocked', '', this.sharedService.getConfig(false));
        },
        error => {
          // console.log('Couldn\'t unlock story');
        });

    this.sharedService.overflowauto();
  }

  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() + ', ' +
        ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
    } else {
      return 'not present';
    }
  }

  getNewTypeDate(datestring) {
    if (datestring) {
      if (typeof datestring === 'string') {
        const dt = new Date(datestring.replace('+0000', 'Z'));
        return this.getFullDate(Math.round(dt.getTime()));
      } else {
        return this.getFullDate(datestring);
      }
    } else {
      return 'not present';
    }
  }


  measureTime(count) {
    if (this.listData && this.listData['length'] === this.pageSize) {
      this.timings.list = performance.now();
      console.log('list loaded => ', performance.now() - this.timings.resp);
      console.log('total first load time => ', performance.now() - this.timings.constr);
    } else if (count < 6) {
      setTimeout(e => {
        this.measureTime(++count);
      }, 0);
    }
  }

  ngOnDestroy() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
    }
  }

  lockAcquire(story_id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
      + '?articleId='
      + String(story_id)
    )
      .subscribe(
        data => {
          callback(data);
        },
        error => {
          callback(false);
        });
  }

  lockRelease(story_id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockRelease_api)
      + '?articleId='
      + String(story_id)
    )
      .subscribe(
        data => {
          // console.log('released => ' + data);
          callback(data);
        },
        error => {
          // console.log(error);
          callback(false);
        });
  }
  openQuickRead(el) {
    this.restService.http_get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
    + '/' + this.listArray[el].id)
    .subscribe(
        data => {
          // console.log(data);
          this.quickReadPopup = true;
          this.storyData = data;
          this.tempQuickRead = this.storyData.quickReadSummary ? this.storyData.quickReadSummary : 'Please Enter Quick Read Summary.';
          if(data && data.lockedByUserId && data.lockedByUserId.length > 0) {
            this.snotify.warning('Story is locked by - ' + data.lockedByUserName, '', this.sharedService.getConfig(false));
          }
          setTimeout(() => {
            this.quickReadPopup = false;
          }, 2500);
        },
        error => {
        });

  }
  checkColorOfQuickRead(item) {
    if(item.quickReadStatus === "Automated") {
      this.quickReadSrc = "assets/images/quick_reads-blue.svg";
    } else if (item.quickReadStatus === "Automated_Edited") {
      this.quickReadSrc = "assets/images/quick_reads-yellow.svg";
    } else if (item.quickReadStatus === "Manual"){
      this.quickReadSrc = "assets/images/quick_reads-green.svg";
    } else {
      this.quickReadSrc = "assets/images/quick_reads-gray.svg";
    }

    return true;
  }
  checkColorOfSummaryRead(item) {
    if(item.summaryStatus === "Automated") {
      this.summaryStatus = "assets/images/summary-blue.svg";
    } else if (item.summaryStatus === "Automated_Edited") {
      this.summaryStatus = "assets/images/summary-yellow.svg";
    } else if (item.summaryStatus === "Manual"){
      this.summaryStatus = "assets/images/summary-green.svg";
    } else {
      this.summaryStatus = "assets/images/summary-gray.svg";
    }
    
    return true;
  }
  cancelQuickReads() {
    this.quickReadPopup = false;
    this.viewParagraph = [];
    this.showQuickReads = true;
    this.showStoryParaView = false;
  }
  saveQuickReads() {
    const token = localStorage.getItem(StaticDataService.tokenLiteral) ?
        JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))
        : null;
    this.storyData['lockedByUserId'] = token.email;
    this.storyData['lockedByUserName'] = token.name;
    this.savingQuickReadInProgress = true;

    if (this.storyData.quickReadSummary.split(' ').length <= this.quickReadMax) {
      this.snotify.success('Saving...', '', this.sharedService.getConfig(false));
      this.lockAcquire(this.storyData.id, (fn) => {
        if(fn !== false) {
          if(this.storyData.quickReadStatus === 'Automated' || this.storyData.quickReadStatus === 'Automated_Edited' ) {
            this.storyData.quickReadStatus = 'Automated_Edited';
          } else {
            this.storyData.quickReadStatus = 'Manual';
          }
          if(this.storyData && this.storyData.quickReadSummary && this.storyData.quickReadSummary.length === 0) {
            this.storyData.quickReadStatus = 'None';
          }
          this.restService.http_put(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api)
          + String(this.storyData.id)+'?autoSave=true',
          this.sharedService.checkhrefandreplace(this.storyData),
            (result) => {
              this.snotify.success('Quick Read Summary Changed Successfully.', '', this.sharedService.getConfig(false));
              this.quickReadPopup = false;
              this.savingQuickReadInProgress = false;
              this.lockRelease(this.storyData.id, (fn) => {
                console.log("lock release => ",fn)
              });
              this.getDefaultList(0, this.dataInsertion);
            });
            this.viewParagraph = [];
            this.showQuickReads = true;
            this.showStoryParaView = false;
        }
        else {
          this.snotify.error('Error Acquiring Lock.', '', this.sharedService.getConfig(false));
          this.quickReadPopup = false;
          this.savingQuickReadInProgress = false;
          this.viewParagraph = [];
          this.showQuickReads = true;
          this.showStoryParaView = false;
        }
        }
      );
    } else {
      this.snotify.error('Length of the quick read summary must be less than ' + this.quickReadMax +' words.', '', this.sharedService.getConfig(false));
      this.savingQuickReadInProgress = false;
    }
  }

  openStory(item) {
    let domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    setTimeout(e2 => {
      window.open(item, "_blank");
    }, 70);
  }

  navigateToFrontendUrl(story) {
    if(story && story.metadata && story.metadata.status && story.metadata.status === 'PUBLISHED') {
      if(story.metadata.url.substring(0,4) === 'http'){
        window.open(story.metadata.url, "_blank");
      } else {
        if(this.sharedService.currentDomainUrl === null || this.sharedService.currentDomainUrl === undefined || this.sharedService.currentDomainUrl.trim() === ''){
          let obj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
          if(obj){
            window.open(obj[0].baseUrl + story.metadata.url, "_blank");
          }
        } else {
          window.open(this.sharedService.currentDomainUrl + story.metadata.url, "_blank");
        }
      }
    }
  }

  getNotificationPopup(item){
    this.restService.http_get(this.config.get('product').notificationServiceUrl + '/api/cms/notifications/'+item.id)
    .subscribe(res=>{
      this.notificationList = res;
      this.openNotificationPopup = true;
    })
  }

  tabIndex(index){
    this.tabIndexValue = index;
  }

  closesendNotifications() {
    this.openNotificationPopup = false;
  }
}
